import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  options: null,
  textToEdit: null,
  isEditModalShown: false,
  isAddModalShown: false,
};

function onLoadSuccess(state, { payload }) {
  const { data } = payload.data;
  const options = data;

  return {
    ...state,
    options,
  };
}

function onClearStore() {
  return { ...initState };
}

function onShowEditModal(state, { payload }) {
  const { item } = payload;

  return {
    ...state,
    isEditModalShown: true,
    textToEdit: {
      item,
    },
  };
}

function onShowAddModal(state, { payload }) {
  const { item } = payload;

  return {
    ...state,
    isAddModalShown: true,
    textToEdit: {
      item,
    },
  };
}

function onCloseModal(state) {
  return {
    ...state,
    isEditModalShown: false,
    isAddModalShown: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.SHOW_ADD_MODAL]: onShowAddModal,
  [actions.SHOW_EDIT_MODAL]: onShowEditModal,
  [actions.CLOSE_MODAL]: onCloseModal,
});
